import { render, staticRenderFns } from "./grossing-touch-view.vue?vue&type=template&id=6a639a4e&"
import script from "./grossing-touch-view.ts?vue&type=script&lang=ts&"
export * from "./grossing-touch-view.ts?vue&type=script&lang=ts&"
import style0 from "./grossing-touch-view.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports